import React, { useContext, useState } from "react";
import AppsIcon from "@mui/icons-material/Apps";
import { Button, Popover } from "@mui/material";
import { useStyles } from "./AppMenu.styles";
import AppMenuItem from "./AppMenuItem.view";
import { useNavigate } from "react-router-dom";
import { CORPORATE_BACKOFFICE_PATHS, USERTYPE } from "constants/constants";
import { useTranslation } from "react-i18next";
import Module1Icon from "components/Module1Icon";
import Module2Icon from "components/Module2Icon";
import { CorporateContext } from "contexts/CorporateContext/CorporateContext";

const AppMenu = () => {
    const [anchorElForAppMenu, setAnchorElForAppMenu] = useState<HTMLButtonElement | null>(null);
    const { rcaEnabled, corporations, currentUser } = useContext(CorporateContext);
    const isOpenAppMenu = Boolean(anchorElForAppMenu);
    const navigate = useNavigate();
    const appMenuId = isOpenAppMenu ? "appMenu-popover" : undefined;
    const classes = useStyles();
    const { t } = useTranslation();
    const handleClickAppMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElForAppMenu(event.currentTarget);
    };

    const handleCloseAppMenu = () => {
        setAnchorElForAppMenu(null);
    };

    const handleNavigateToAspen = () => {
        if (
            currentUser?.user_type.user_type_id === USERTYPE.ADMINISTRATOR ||
            currentUser?.user_type.user_type_id === USERTYPE.EXECUTIVE ||
            currentUser?.user_type.user_type_id === USERTYPE.OSORNOADMINISTRATOR
        ) {
            if (corporations[0]?.mills?.length === 1) {
                navigate(
                    `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.LOCATIONS.ROOT}/${corporations[0]?.mills[0].mill_id}`,
                );
            } else {
                navigate(`/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.CORPORATE_DASHBOARD}`);
            }
        } else {
            navigate(
                `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.LOCATIONS.ROOT}/${
                    currentUser?.mill?.mill_id || 0
                }`,
            );
        }
        handleCloseAppMenu();
    };

    const handleNavigateToRCA = () => {
        if (rcaEnabled) {
            navigate(`/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}`);
            handleCloseAppMenu();
        }
    };

    return (
        <>
            <Button onClick={handleClickAppMenu} aria-describedby={appMenuId}>
                <AppsIcon className={classes.appMenu} />
            </Button>
            <Popover
                id={appMenuId}
                open={isOpenAppMenu}
                anchorEl={anchorElForAppMenu}
                onClose={handleCloseAppMenu}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <main className={classes.mainWrapper}>
                    <AppMenuItem
                        icon={<Module1Icon className={classes.appMenuIcon} hideBackground />}
                        text={t("corporate_backoffice.corporate_layout.app_drawer.app_menu.downtime")}
                        onClick={handleNavigateToAspen}
                    />
                    <AppMenuItem
                        icon={<Module2Icon className={classes.appMenuIcon} hideBackground />}
                        text={t("corporate_backoffice.corporate_layout.app_drawer.app_menu.rca")}
                        onClick={handleNavigateToRCA}
                    />
                </main>
            </Popover>
        </>
    );
};

export default AppMenu;
